"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkMaxHeadCountAdjustment = exports.getMinDateAllowed = exports.getNoticePeriod = exports.calculateOptions = exports.getLatestTime = exports.getEarliestTime = exports.timePopoverFormat = void 0;
const date_fns_1 = require("date-fns");
const date_1 = require("./date");
const types_shared_1 = require("../types.shared");
const TIME_DELIMITER = 30;
const TIME_GAP = 15;
const padString = (num, pad = 4) => num
    .toString()
    .padStart(pad, '0')
    .replace(/^(.{2})(.{1,2})$/, '$1:$2');
const timePopoverFormat = ({ startTime, endTime, chosenTime, }) => {
    const options = [];
    const [startHours, startMins] = padString(startTime).split(':');
    let currentTime = (0, date_fns_1.set)(new Date(), { hours: Number(startHours), minutes: Number(startMins) });
    const [endHours, endMins] = padString(endTime).split(':');
    const endingTime = (0, date_fns_1.set)(new Date(), {
        hours: Number(endHours),
        minutes: Number(endMins) - (TIME_DELIMITER - 1),
    });
    while ((0, date_fns_1.isBefore)(currentTime, endingTime)) {
        const currentTimeMax = (0, date_fns_1.add)(currentTime, { minutes: TIME_DELIMITER });
        const startString = (0, date_fns_1.format)(currentTime, 'HH:mm');
        currentTime = (0, date_fns_1.add)(currentTime, { minutes: TIME_GAP });
        if (chosenTime && Number(startString.replace(':', '')) < chosenTime)
            continue;
        options.push(`${startString} - ${(0, date_fns_1.format)(currentTimeMax, 'HH:mm')}`);
    }
    return options;
};
exports.timePopoverFormat = timePopoverFormat;
const getEarliestTime = (openingTimes) => openingTimes.reduce((acc, location) => Math.min(location.startTime ? Number(location.startTime.replace(':', '')) : Number.POSITIVE_INFINITY, acc), Number.POSITIVE_INFINITY);
exports.getEarliestTime = getEarliestTime;
const getLatestTime = (openingTimes) => openingTimes.reduce((acc, location) => Math.max(location.endTime ? Number(location.endTime.replace(':', '')) : 0, acc), 0);
exports.getLatestTime = getLatestTime;
const calculateOptions = (vendorLocations, date, useDeliveryTimes, deliveryTimeRange) => {
    let startTime = Number.POSITIVE_INFINITY;
    let endTime = 0;
    const weekday = date ? date_1.datepickerFixedDays[(0, date_fns_1.getDay)(date)] : undefined;
    for (const location of vendorLocations || []) {
        if (!(location === null || location === void 0 ? void 0 : location.openingTimes.length))
            continue;
        const openingTimes = location.openingTimes.filter((time) => {
            if (!weekday)
                return true;
            return time.weekdays.includes(weekday);
        });
        if (!openingTimes.length)
            continue;
        const earliestTime = (0, exports.getEarliestTime)(openingTimes);
        const latestTime = (0, exports.getLatestTime)(openingTimes);
        startTime = Math.min(startTime, earliestTime);
        endTime = Math.max(endTime, latestTime);
    }
    const tenantStartTime = (deliveryTimeRange === null || deliveryTimeRange === void 0 ? void 0 : deliveryTimeRange.start) ? Number(deliveryTimeRange.start) : 800;
    const tenantEndTime = (deliveryTimeRange === null || deliveryTimeRange === void 0 ? void 0 : deliveryTimeRange.end) ? Number(deliveryTimeRange.end) : 1800;
    startTime = Math.max(startTime, tenantStartTime);
    endTime = Math.min(endTime, tenantEndTime);
    const minStartTime = date && (0, date_fns_1.isWeekend)(date) ? 800 : tenantStartTime;
    if (startTime === Number.POSITIVE_INFINITY || (startTime < minStartTime && !useDeliveryTimes))
        startTime = minStartTime;
    if (endTime === 0 || (endTime > tenantEndTime && !useDeliveryTimes))
        endTime = date && (0, date_fns_1.isWeekend)(date) ? 1800 : tenantEndTime;
    return { startTime, endTime };
};
exports.calculateOptions = calculateOptions;
const getNoticePeriod = (selectedVendorLocations, headCount) => {
    if (!(selectedVendorLocations === null || selectedVendorLocations === void 0 ? void 0 : selectedVendorLocations.length))
        return 0;
    const minNotice = selectedVendorLocations.reduce((min, location) => {
        var _a;
        let gmMinNoticePeriod = Math.min(((_a = location === null || location === void 0 ? void 0 : location.details) === null || _a === void 0 ? void 0 : _a.gmMinNoticePeriod) || Number.POSITIVE_INFINITY, min);
        if (headCount && headCount > (location.details.gmLargeOrderThreshold || Number.POSITIVE_INFINITY)) {
            gmMinNoticePeriod = location.details.gmLargeOrderNoticePeriod || gmMinNoticePeriod;
        }
        return gmMinNoticePeriod;
    }, Number.POSITIVE_INFINITY);
    return minNotice === Number.POSITIVE_INFINITY ? 0 : minNotice;
};
exports.getNoticePeriod = getNoticePeriod;
const getMinDateAllowed = (selectedVendorLocations, userState, useDeliveryTimes) => {
    const noticeHours = (0, exports.getNoticePeriod)(selectedVendorLocations, userState === null || userState === void 0 ? void 0 : userState.headCount);
    const getTimeOptions = (date) => {
        const minTimeOnDay = Number(Number((0, date_fns_1.format)(date, 'HHmm')));
        return (0, exports.timePopoverFormat)({
            ...(0, exports.calculateOptions)(selectedVendorLocations, userState === null || userState === void 0 ? void 0 : userState.date, useDeliveryTimes),
            chosenTime: minTimeOnDay,
        });
    };
    return (0, date_1.addDurationToDateConsideringSomeDays)(new Date(), { hours: noticeHours }, (date) => {
        const everyLocationIsNotOpen = selectedVendorLocations && selectedVendorLocations.length > 0
            ? selectedVendorLocations.every(({ closingDates }) => closingDates.closedWeekdays.includes((0, date_fns_1.getISODay)(date)) ||
                closingDates.closedDates.some((closedDate) => (0, date_fns_1.isSameDay)(new Date(closedDate), date)))
            : false;
        if (everyLocationIsNotOpen)
            return false;
        return getTimeOptions(date).length > 0;
    });
};
exports.getMinDateAllowed = getMinDateAllowed;
const checkMaxHeadCountAdjustment = (usersDate, userState, vendorLocations) => {
    const time = userState.time ? userState.time.split(' ')[0].split(':') : ['23', '59'];
    usersDate.setHours(Number.parseInt(time[0], 10));
    usersDate.setMinutes(Number.parseInt(time[1], 10));
    usersDate.setSeconds(0);
    const minDate = (0, exports.getMinDateAllowed)(vendorLocations, userState);
    const maxHeadCount = vendorLocations.reduce((acc, location) => Math.min(location.details.gmLargeOrderThreshold || Number.POSITIVE_INFINITY, acc), Number.POSITIVE_INFINITY) || Number.POSITIVE_INFINITY;
    if (minDate > usersDate && (userState.headCount || 0) > maxHeadCount) {
        return {
            result: (0, types_shared_1.error)({ code: 'CLOSED_LARGE_ORDER' }),
            newLocations: vendorLocations,
        };
    }
    if ((0, date_1.isBeforeNotSame)(minDate, usersDate)) {
        return {
            result: (0, types_shared_1.error)({ code: 'DATE_PAST' }),
            newLocations: vendorLocations,
        };
    }
    return null;
};
exports.checkMaxHeadCountAdjustment = checkMaxHeadCountAdjustment;
